export const CLINIC = {
  name: "Litisha Foot Care",
  tagline: "Professional Mobile Foot Care Clinic",
  phone: "07547 173220",
  phoneRaw: "07547173220",
  whatsapp: "https://wa.me/447547173220",
  email: "info@litishafootcare.co.uk",
  socials: {
    facebook: "https://www.facebook.com/share/1DhdZ4gFkh/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/litisha_foot_care?igsh=MW4zaXFhNzAxcGtraQ%3D%3D&utm_source=qr",
  },
  areas: [
    "West Lothian",
    "Midlothian",
    "North Lanarkshire",
    "Fife",
    "Falkirk",
    "Kinross",
  ],
};

export const SERVICES = [
  {
    id: "assessment",
    title: "Initial Assessment & Neurovascular Examination",
    short: "Comprehensive foot health evaluation including medical history, circulation and sensation checks, plus a personalised care plan.",
    icon: "Stethoscope",
    duration: "Up to 45 minutes",
    bullets: [
      "Detailed medical history",
      "Neurovascular & sensation checks",
      "Skin and nail evaluation",
      "Personalised treatment plan",
    ],
  },
  {
    id: "routine",
    title: "Routine Medical Foot Care",
    short: "Regular maintenance to keep feet healthy, comfortable and mobile — including nail trimming, callus reduction and skin care.",
    icon: "Sparkles",
    duration: "Up to 30 minutes",
    bullets: [
      "Nail trimming & thickened nail reduction",
      "Corn and callus reduction",
      "Cracked heel management",
      "Footwear and self-care advice",
    ],
  },
  {
    id: "diabetic",
    title: "Diabetic Foot Care",
    short: "Specialist assessments and care to reduce the risk of ulcers, infections and circulation problems for people living with diabetes.",
    icon: "ShieldCheck",
    duration: "Up to 30 minutes",
    bullets: [
      "Diabetic foot assessments",
      "Circulation & sensation testing",
      "Pressure area evaluation",
      "Preventative education",
    ],
  },
  {
    id: "fungal",
    title: "Fungal Nail Treatment",
    short: "Professional management for thickened, brittle or discoloured nails to improve nail health and appearance.",
    icon: "Droplets",
    duration: "Up to 30 minutes",
    bullets: [
      "Nail reduction & debridement",
      "Topical treatment guidance",
      "Nail fenestration support",
      "Ongoing monitoring",
    ],
  },
  {
    id: "fenestration",
    title: "Nail Fenestration",
    short: "An advanced, minimally invasive technique that creates micro-holes to help antifungal medications penetrate effectively.",
    icon: "CircleDot",
    duration: "Up to 30 minutes",
    bullets: [
      "Improves topical absorption",
      "Minimally invasive",
      "Pairs with fungal nail care",
      "Performed in your home",
    ],
  },
  {
    id: "ingrown",
    title: "Ingrown Toe Nail Treatment",
    short: "Conservative ingrown toenail management without surgery — relieving pain and preventing recurrence.",
    icon: "Scissors",
    duration: "Up to 30 minutes",
    bullets: [
      "Gentle nail correction",
      "Removal of offending edges",
      "Pressure relief",
      "Cutting & footwear advice",
    ],
  },
  {
    id: "bracing",
    title: "Toe Nail Bracing for Involuted Nails",
    short: "Non-invasive corrective bracing that gently guides curved or involuted nails into a healthier shape as they grow.",
    icon: "Workflow",
    duration: "Up to 30 minutes",
    bullets: [
      "Reduces pain & pressure",
      "Improves nail alignment",
      "Prevents recurrent ingrowns",
      "Comfortable & conservative",
    ],
  },
  {
    id: "redecoration",
    title: "Toe Nail Redecoration",
    short: "Restore the cosmetic appearance of damaged or discoloured toenails with a careful, hygienic redecoration treatment.",
    icon: "Palette",
    duration: "Up to 30 minutes",
    bullets: [
      "Natural-looking finish",
      "Suitable post-trauma",
      "Helpful after fungal damage",
      "Confidence-boosting",
    ],
  },
  {
    id: "verruca",
    title: "Verruca Treatment — Verruca Banish",
    short: "Advanced Verruca Banish treatment for stubborn or painful verrucae, with personalised treatment plans.",
    icon: "Target",
    duration: "Up to 30 minutes",
    bullets: [
      "Reduces discomfort",
      "Stimulates healing response",
      "Supports skin recovery",
      "Minimises recurrence",
    ],
  },
  {
    id: "insoles",
    title: "Offloading Insoles",
    short: "Customised insoles to redistribute pressure away from painful areas — easing calluses, corns and verrucae.",
    icon: "Footprints",
    duration: "Up to 30 minutes",
    bullets: [
      "Painful calluses",
      "Neurovascular corns",
      "Pressure lesions",
      "Forefoot discomfort",
    ],
  },
  {
    id: "home-visit",
    title: "Home Visit Foot Care Service",
    short: "Professional treatment delivered to your doorstep — ideal for elderly patients, reduced mobility, or busy schedules.",
    icon: "Home",
    bullets: [
      "Elderly patients",
      "Reduced mobility",
      "Post-surgery recovery",
      "Busy professionals",
    ],
  },
];
